module.exports = new __parcel__URL__("Paladinskill_02.d8cae53c.png").toString();